import React, { useState } from "react";
import { Box, Heading, Text, Button } from "grommet";
import { useParams } from "react-router-dom";
import { Info } from "grommet-icons";
import ManageUsers from "./ManageUsers";
import ManageUsersTourModal from "./ManageUsersTourModal";

const UsersGroupManagement = () => {
  const { manager_id } = useParams();
  const [showModal, setShowModal] = useState(false);

  return (
    <Box
      flex="grow"
      pad={{ horizontal: "small", vertical: "small" }}
      gap="medium"
    >
      {/* Main Content Row */}
      <Box
        direction="row"
        gap="medium"
        align="start"
        justify="between"
        margin={{ top: "xsmall" }}
      >
        {/* Left Box: Info and ManageUsers component */}
        <Box flex="grow" pad={{ vertical: "small", horizontal: "small" }}>
          {/* Info Section */}
          <Box
            pad="medium"
            background="light-2"
            round="small"
            elevation="small"
            margin={{ bottom: "medium" }}
          >
            <Box direction="row" align="center" gap="small">
              <Info size="medium" color="brand" />
              <Heading level="3" margin="none" color="brand">
                Manage users
              </Heading>
            </Box>
            <Text margin={{ top: "small" }} size="medium">
              This section provides an overview of all invited users, including
              their assessment status—Open (assigned but not yet completed),
              Closed (completed), and Self (initiated by the user)—as well as
              their invite status (Pending, Active, or Declined). You can view
              detailed assessment information, send reminder emails for pending
              invites, or remove users with pending status. Please note that
              active users cannot be deleted directly. To know more details
              about this page,{" "}
              <Text
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => setShowModal(true)}
              >
                click here.
              </Text>
            </Text>
          </Box>

          {/* ManageUsers Component */}
          <Box
            pad={{ vertical: "small", horizontal: "small" }}
            background="light-1"
            round="small"
            elevation="small"
          >
            <ManageUsers manager_id={manager_id} />
          </Box>
        </Box>
      </Box>
      <ManageUsersTourModal showModal={showModal} setShowModal={setShowModal} />
    </Box>
  );
};

export default UsersGroupManagement;
